import { render, staticRenderFns } from "./addColumnLebel.vue?vue&type=template&id=4f541490"
import script from "./addColumnLebel.vue?vue&type=script&lang=js"
export * from "./addColumnLebel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports